import { render, staticRenderFns } from "./DropzoneBase.vue?vue&type=template&id=fa65ba00&scoped=true&"
import script from "./DropzoneBase.vue?vue&type=script&lang=js&"
export * from "./DropzoneBase.vue?vue&type=script&lang=js&"
import style0 from "./DropzoneBase.vue?vue&type=style&index=0&id=fa65ba00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa65ba00",
  null
  
)

export default component.exports